import { cache, } from "./cache";
import { wagmiConfig, } from "@wagmiconfig";
import * as P from "@bracket/contractor-next/pricing";

import type { Config, } from "wagmi";


export const latestPriceBtc = async ({
	config = wagmiConfig,
}: {
	config?: Config;
} = {}): Promise<number> => {
	const now = Date.now();
	const {
		time,
		value,
		since,
	} = cache.latest_price_btc;
	if(since > now - time) {
		return value;
	}
	const next = await P.getLatestPrice({ token: "BTC_USD", config, });
  cache.latest_price_btc.since = Date.now();
  cache.latest_price_btc.value = next;
  return next;
}
